import { connect } from "react-redux";
import { useState } from "react";
import { Select } from "antd";
import { Note, Page } from "../../../helbest";
import {
  _set_channel,
  set_checkout_id,
} from "../../../store/actions/login_actions";
import { _Cart_Clean } from "../../../store/actions/cart_actions";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";

// icons
import { ReactComponent as BottomArrow } from "../../../assets/svg/bottom-arrow.svg";
import Button from "../../components/ui/Button";
import { useChannelsQuery } from "../../../saleor/api";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { calculator } from "../../../base/utils";

const { Option } = Select;

export const ChangeStoreLocation = (props) => {
  const navigate = useLangNavigate();
  const [selectedChannel, setSelectedChannel] = useState([]);

  const { data: channelsData } = useChannelsQuery({
    variables: {},
  });

  const set_store = () => {
    if (!selectedChannel) {
      Note.error("please select your province and your city");
      return;
    }
    props.dispatch(_Cart_Clean());
    props.dispatch(_set_channel(selectedChannel));
    props.dispatch(set_checkout_id({ checkout_id: "" }));
    calculator();
    navigate("/");
  };
  return (
    <Page
      className="page-change-store-location"
      back={true}
      customHeader={<HeaderBack title="Province / City" />}
      address="/"
      logo
    >
      <div className="desktop-mode change-store-location-container">
        <p className="justify-between items-center">
          Select your preffered Channel
        </p>
        <Select
          className="change-store-location-select"
          popupClassName="change-store-dropdown"
          placeholder="Channel"
          suffixIcon={<BottomArrow width={10} height={10} />}
          onChange={(value) => setSelectedChannel(value)}
          placement="bottomRight"
        >
          <Option value={null}></Option>
          {[].map((country, pdx) => {
            return (
              <Option key={pdx} value={country.id}>
                {country.name}
              </Option>
            );
          })}
        </Select>
      </div>
      <div className="page-change-store-location-box">
        <Button onClick={set_store} style_width="100%">
          Change Province / City
        </Button>
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login,
});

export default connect(mapStateToProps)(ChangeStoreLocation);
